import styled from "styled-components";

export const FreeTextLayout = styled.div<{ $background?: string }>(({ theme, $background }) => ({
    display: "flex",
    position: "relative",
    overflow: "hidden",
    margin: `${theme.spacing.medium} calc(${theme.spacing.medium} * -1) ${theme.spacing.xxSmall}`,
    padding: `${theme.spacing.xxSmall} ${theme.spacing.medium} calc(${theme.spacing.xxSmall} + 1px)`,
    ...($background ? { background: $background } : {}),
}));

export const ShimmerTextWrapper = styled.span({
    position: "relative",
    display: "inline-flex",
});

export const ShimmerTextContent = styled.span({
    position: "relative",
    zIndex: 1,
});
